import { useCommonWidgetHandlers } from './use-common-widget-handlers';
import SendDataWidget from '../../../editor/features/build/requestModels/widgets/SendDataWidget';

export const useConnectionWidgetHandlers = () => {
  const commonWidgetHandlers = useCommonWidgetHandlers();

  const addNew = (
    dialogueId: number,
    sortOrder: number,
    kind:
      | 'google_sheets'
      | 'zapier'
      | 'mailchimp'
      | 'slack'
      | 'facebook_ads_audience' = 'zapier',
    zapName?: string,
  ) => {
    const newWidget = SendDataWidget.make(dialogueId, sortOrder, kind, zapName);

    return commonWidgetHandlers.create(newWidget, dialogueId, sortOrder);
  };

  return {
    update: commonWidgetHandlers.update,
    addNew,
  };
};
